import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";
import { backendPatch, backendPost } from "services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function useInsurerActions() {
  const [backendData, setBackendData] = useRecoilState(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state = backendData?.data ? backendData : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "insurer-list",
      data: data,
    });
  };

  const uploadEmailList = async (form_data) => {
    form_data.api_version = "v2";

    await backendPost("data/ansprechpartners/upload", {
      label: "Ansprechpartner-E-Mail-Adressen",
      toSend: form_data,
      enqueueSnackbar,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res);
      },
    });
  };

  const updateEmail = async (insurer_id, form_data) => {
    return await backendPatch(`data/insurers/${insurer_id}/email`, {
      label: "Schaden-E-Mail der Versicherungsgesellschaft",
      toSend: form_data,
      enqueueSnackbar,
      successMessage: "E-Mail wurde aktualisiert.",
      setResult: (res) => {
        const updated_insurer = res?.data ?? res;
        updateListItemState(backendData, setBackendData, updated_insurer);
      },
    });
  };

  return {
    updateEmail,
    setState,
    state,
  };
}
